import About from '../components/sections/About/About';
import Speakers from '../components/sections/Speakers/Speakers';
import Committee from '../components/sections/Committee/Committee';
import Programme from '../components/sections/Programme/Programme';
import Venue from '../components/sections/Venue/Venue';
import Partners from '../components/sections/Partners/Partners';

const pages = {
    about: About,
    speakers: Speakers,
    committee: Committee,
    programme: Programme,
    venue: Venue,
    partners: Partners,
};

export default function Page(name, conference = {}) {

    const Component = pages[name];

    if (!Component) {
        return `
            <section class="page-not-found">
                <div class="container">
                    <h1>Page not found</h1>
                </div>
            </section>
        `;
    }

    return Component({ conference });
}
